module.exports = __webpack_public_path__ + "static/media/unlock.2f89b2f1.svg";